const API_BASE_URL = "https://rjback.freshgrad.com/api";   //       // https://rjback.freshgrad.com/api/
const ADMIN_API_BASE_URL = "https://rjback.freshgrad.com/adminapi";   // https://rjback.freshgrad.com/adminapi
const IMG_BASE_URL = "https://freshgradpublic.s3.us-east-1.amazonaws.com/Training+Program_files";

export { API_BASE_URL, ADMIN_API_BASE_URL, IMG_BASE_URL }